import api from '@/api/user'

const state = {
  token: localStorage.getItem('admin_token') || '',
  user: JSON.parse(localStorage.getItem('admin_user') || 'null'),
  permissions: []
}

const getters = {
  isAuthenticated: state => !!state.token,
  currentUser: state => state.user,
  userPermissions: state => state.permissions
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('admin_token', token)
    } else {
      localStorage.removeItem('admin_token')
    }
  },
  SET_USER(state, user) {
    state.user = user
    if (user) {
      localStorage.setItem('admin_user', JSON.stringify(user))
    } else {
      localStorage.removeItem('admin_user')
    }
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  CLEAR_AUTH(state) {
    state.token = ''
    state.user = null
    state.permissions = []
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_user')
  }
}

const actions = {
  async login({ commit }, credentials) {
    try {
      const response = await api.login(credentials)
      commit('SET_TOKEN', response.data.token)
      commit('SET_USER', response.data.user)
      commit('SET_PERMISSIONS', response.data.permissions || [])
      return response.data
    } catch (error) {
      commit('CLEAR_AUTH')
      throw error
    }
  },

  async logout({ commit }) {
    try {
      await api.logout()
    } finally {
      commit('CLEAR_AUTH')
    }
  },

  async getProfile({ commit, state }) {
    if (!state.token) return
    try {
      const response = await api.getProfile()
      commit('SET_USER', response.data)
    } catch (error) {
      commit('CLEAR_AUTH')
      throw error
    }
  }
}

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
}
